






import { Component, Vue } from "vue-property-decorator";
import { namespace } from "vuex-class";

const indexModule = namespace("index");

@Component
export default class Main extends Vue {
	active: number = 1;
}
